import React from 'react'

import { Container } from './styles'

export default function SubTitle({ children }){
    return (
        <Container>
            {children}
        </Container>
    )
}